<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 用户管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="用户昵称:" label-width="75px">
                        <el-input v-model="query.nickname" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="所属员工ID:" label-width="90px">
                        <el-input v-model="query.employ_id" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                     <el-form-item label="所属财务公司ID:" label-width="130px">
                        <el-input v-model="query.fincpy_id" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
           
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                
            >
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="nickname" label="用户昵称" width="250" align="center"></el-table-column>
                <el-table-column prop="openid" label="openid" width="300"  align="center"></el-table-column>
                <el-table-column prop="sex" label="性别" width="80px" align="center">
                      <template slot-scope="scope">
                        <span v-if="scope.row.sex ==0">暂无</span>
                           <span v-else-if="scope.row.sex ==1">男</span>
                            <span v-else-if="scope.row.sex ==2">女</span>
                        </template>
                </el-table-column>
                <el-table-column prop="headimgurl" label="用户头像"  align="center">
                            <template slot-scope="scope">
                            <el-image
                                class="table-td-thumb"
                                :src="scope.row.headimgurl"
                                :preview-src-list="[scope.row.headimgurl]"
                            ></el-image>
                        </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间"  align="center" width="200px"></el-table-column>
                <el-table-column prop="employ_id" label="所属员工id" width="130px"  align="center">
                    <template slot-scope="scope">
                           <span v-if="scope.row.employ_id ==0">暂无</span>
                           <span v-else>{{scope.row.employ_id}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fincpy_id" label="所属财务公司id" width="160px" align="center">
                    <template slot-scope="scope">
                           <span v-if="scope.row.fincpy_id ==0">暂无</span>
                           <span v-else>{{scope.row.fincpy_id}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="260" align="center">
                    <template slot-scope="scope">
                         <el-button size="mini" 
                            type="primary"
                            @click="handleEdit(scope.$index,scope.row)"
                        >
                        分配员工
                        </el-button>
                         <el-button size="mini" 
                            type="warning"
                            @click="handleEdit1(scope.$index,scope.row)"
                        >
                        分配财务公司
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
          <el-dialog title="分配员工" :visible.sync="editVisible" width="500px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="100px" >
               <el-form-item prop="nickname" label="用户昵称">
                      {{editForm.nickname}}
               </el-form-item>
               <el-form-item prop="employ_id" label="员工">
                    <el-select v-model="editForm.employ_id" filterable>
                        <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
               </el-form-item>
            </el-form>
      
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>
        <!--财务公司-->
          <el-dialog title="分配财务公司" :visible.sync="editVisible1" width="500px">
            <el-form ref="editForm1" :rules="rules" :model="editForm1" label-width="100px" >
               <el-form-item prop="nickname" label="用户昵称">
                      {{editForm1.nickname}}
               </el-form-item>
               <el-form-item prop="fincpy_id" label="财务公司">
                       <el-select v-model="editForm1.fincpy_id" filterable>
                        <el-option
                            v-for="item in fiList"
                            :key="item.id"
                            :label="item.company_name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
               </el-form-item>
            </el-form>
         
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit1()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>


import { post } from '../../../api/request';

export default {
    name: 'basetable',
    data() {
        return {
            userList:[],
            fiList:[],
            //编辑数据
            editVisible:false,
            editForm:{},
            editForm1:{},
            editVisible1:false,
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query: {
                nickname: '',
                employ_id:"",
                fincpy_id:"",
                pageIndex: 1,
                pageSize: 8
            },
            pageTotal: 0,
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1,
            rules: {
                employ_id: [
                    { required: true, message: '请选择员工', trigger: 'blur' },
                ]
               
            },
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.getList()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.getList()
    },
    
    methods: {
        getList(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',1)
            formdata.append('limit',1010000000000)
            post('admin/employees/employinfo',formdata).then(res => {
                if(res.code=200){
                    this.userList = res.data.data.list;
                }
            });
            post('admin/financecpy/showFincpy',formdata).then(res => {
                if(res.code=200){
                    this.fiList = res.data.data.list;
                }
            });
        },
         // 分配员工
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editVisible = true;
        },
        // 分配员工保存编辑
        saveEdit() {
            console.log(this.editForm.employ_id)
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('id',this.editForm.id)
                    formdata.append('employ_id',this.editForm.employ_id)
                    post('admin/user/fenEmp',formdata).then(res=>{
                        if(res.data.msg == "分配成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else if(res.data.msg =="分配失败,该用户已属于该员工"){
                              this.$message.warning('分配失败,该用户已属于该员工')
                        }
                        else{
                            this.$message.error('分配失败')
                        }
                    
                    })
                }
            })
        },
          // 分配财务公司
        handleEdit1(index, row) {
            this.idx = index;
            this.editForm1 = Object.assign({}, row);
            this.editVisible1 = true;
        },
        // 分配财务公司
        saveEdit1() {
            this.$refs['editForm1'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('id',this.editForm1.id)
                    formdata.append('fincpy_id',this.editForm1.fincpy_id)
                    post('admin/user/fenFin',formdata).then(res=>{
                        if(res.data.msg == "分配成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible1 = false
                        }
                        else if(res.data.msg =="分配失败,该用户已属于该员工"){
                              this.$message.warning('分配失败,该用户已属于该员工')
                        }
                        else{
                            this.$message.error('分配失败')
                        }
                    
                    })
                }
            })
        },
      
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //重置搜索
        resetsearch(){
            this.query.nickname= '',
            this.query.employ_id='',
            this.query.fincpy_id='',
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('nickname',this.query.nickname)
            formdata.append('employ_id',this.query.employ_id)
            formdata.append('fincpy_id',this.query.fincpy_id)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            post('admin/user/userlist',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                    }
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('nickname',this.query.nickname)
            formdata.append('employ_id',this.query.employ_id)
            formdata.append('fincpy_id',this.query.fincpy_id)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            post('admin/user/userlist',formdata).then(res => {
                if(res.data.data.list){
                    this.tableData = res.data.data.list
                     this.pageTotal = res.data.data.num
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/seal/deleseal',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            if(this.pageTotal/this.query.pageSize<this.query.pageIndex)
                                this.query.pageIndex = this.query.pageIndex -1
                            this.getData()    
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
